import { parseISO } from "date-fns";
import normalizeUrl from "../../../utils/normalize-url";
//NOTE: A CheckEnvironment method is required!
const ENVIRONMENT = process.env.NODE_ENV;

export enum PriorityType {
  "High" = "High",
  "Medium" = "Medium",
  "Low" = "Low",
}

export enum NewsletterType {
  "Guest" = "Guest",
  "Internal" = "Internal",
  "Owner" = "Owner",
}

function CheckEnvironment() {
  if (!ENVIRONMENT) {
    throw new Error("Please add environment to env file.");
  }
  return ENVIRONMENT?.toLowerCase() === "development";
}

function AssertPortalType(type: NewsletterType) {
  if (type !== NewsletterType.Internal) {
    throw new Error("Incompatable notification recived.");
  }
  return true;
}

// { [date.str]: PortalNotification['id'] }
export type ReadPortalNotification = Record<PortalNotification["id"], string>;

export class PortalNotification {
  //? ISO dates are not use on the Map written to firestore. <UTC>
  created_date_ISO: Date;

  last_modified_date_ISO: Date;

  priority_sort_order: number;

  constructor(
    public readonly active: boolean,
    public readonly id: string,
    public readonly priority: PriorityType,
    public readonly subject: string,
    public readonly message: string,
    public readonly actionLinkUrl: string,
    public readonly actionLinkText: string = "More Info",
    public readonly created_date_utc: string,
    public readonly type: NewsletterType,
    public last_modified_date_utc: string
  ) {
    !CheckEnvironment() && AssertPortalType(this.type);

    this.created_date_ISO = parseISO(this.created_date_utc);
    this.last_modified_date_ISO = parseISO(this.last_modified_date_utc);
    this.priority_sort_order =
      this.priority === PriorityType.High
        ? 0
        : this.priority === PriorityType.Medium
        ? 1
        : 2;
  }
  get hasLink() {
    return typeof this.actionLinkUrl === "string" && this.actionLinkUrl !== "";
  }
}

export function InstantiatePortalNotificationFromJSON(json: any) {
  const actionLinkUrl = json.action_link_url
    ? normalizeUrl(json.action_link_url)
    : "";
  return new PortalNotification(
    json.active,
    json.id,
    json.priority,
    json.subject,
    json.message,
    actionLinkUrl,
    json.action_link_text,
    json.created_date_utc,
    json.type,
    json.last_modified_date_utc
  );
}
